(() => {
  const form = document.querySelector('[data-nano-contact]');
  if (!form) return;
  let messages = {};
  try { messages = JSON.parse(form.querySelector('[data-contact-messages]')?.textContent || '{}'); } catch (_) {}
  const message = (key) => messages[key] || '';
  const preview = form.dataset.contactPreview === 'true';
  const draftKey = 'nano-contact-pending-v1';
  if (!preview && form.querySelector('[data-server-accepted]')) {
    // Only Shopify's server-confirmed success branch renders this marker.
    try { sessionStorage.removeItem(draftKey); } catch (_) {}
    form.querySelector('[data-contact-success]')?.focus();
    return;
  }
  const fields = [...form.querySelectorAll('[name^="contact["]')];
  const topic = form.querySelector('#contact-topic');
  const order = form.querySelector('#contact-order');
  const orderRow = form.querySelector('[data-order-field]');
  const feedback = form.querySelector('[data-contact-errors]');
  const progress = form.querySelector('[data-contact-progress]');
  const button = form.querySelector('[type="submit"]');
  const label = button.querySelector('[data-submit-label]');
  const lifetime = 30 * 60 * 1000;
  const orderTopics = new Set(['Payments', 'Delivery and tracking', 'Warranty', 'Returns and refunds']);
  let attempted = false;
  let submitting = false;

  function discardDraft() { try { sessionStorage.removeItem(draftKey); } catch (_) {} }
  function rememberDraft() {
    if (preview) return;
    const values = Object.fromEntries(fields.map(field => [field.name, field.value]));
    try { sessionStorage.setItem(draftKey, JSON.stringify({time:Date.now(),values})); } catch (_) {}
  }
  function recoverDraft() {
    if (preview) return;
    try {
      const draft = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
      if (!draft) return;
      if (!draft.time || Date.now() - draft.time > lifetime) { discardDraft(); return; }
      fields.forEach(field => { if (typeof draft.values?.[field.name] === 'string') field.value = draft.values[field.name]; });
    } catch (_) { discardDraft(); }
  }
  function updateOrder() {
    const relevant = orderTopics.has(topic.value);
    orderRow.hidden = !relevant;
    order.disabled = !relevant;
    // Keep a previously typed number when changing topics; omit it from unrelated submissions.
  }
  function setSubmitting(value) {
    submitting = value;
    form.setAttribute('aria-busy', String(value));
    button.setAttribute('aria-disabled', String(value));
    label.textContent = value ? (preview ? message('checking') : message('sending')) : message('send');
    progress.hidden = !value;
    progress.textContent = value ? (preview ? message('checking_preview') : message('sending')) : '';
  }
  function errorFor(field) {
    if (field.disabled || !field.required) return '';
    if (!field.value.trim()) return ({'contact-name':message('name_required'),'contact-email':message('email_required'),'contact-topic':message('topic_required'),'contact-message':message('message_required')})[field.id];
    if (field.type === 'email' && field.validity.typeMismatch) return message('email_invalid');
    return '';
  }
  function validateField(field) {
    const message = errorFor(field);
    const target = form.querySelector(`#${field.id}-error`);
    if (target) { target.textContent = message; target.hidden = !message; }
    if (message) field.setAttribute('aria-invalid','true');
    else field.removeAttribute('aria-invalid');
    return message;
  }
  function showError(message, errors = []) {
    feedback.replaceChildren();
    const text = document.createElement('p'); text.textContent = message; feedback.append(text);
    if (errors.length) {
      const list = document.createElement('ul');
      errors.forEach(({field,message}) => {
        const item = document.createElement('li'), link = document.createElement('a');
        link.href = `#${field.id}`; link.textContent = message;
        link.addEventListener('click', event => { event.preventDefault(); field.focus(); });
        item.append(link); list.append(item);
      });
      feedback.append(list);
    }
    feedback.hidden = false;
    feedback.focus();
  }

  recoverDraft();
  form.querySelector('[data-preview-guard]')?.removeAttribute('disabled');
  updateOrder();
  topic.addEventListener('change', updateOrder);
  fields.forEach(field => {
    field.addEventListener('blur', () => { if (attempted || field.value) validateField(field); });
    field.addEventListener('input', () => { if (field.hasAttribute('aria-invalid')) validateField(field); });
    field.addEventListener('change', () => { if (attempted) validateField(field); });
  });
  function validateSubmission(event) {
    if (submitting) { event.preventDefault(); event.stopImmediatePropagation(); return false; }
    attempted = true;
    const errors = fields.map(field => ({field,message:validateField(field)})).filter(error => error.message);
    if (errors.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(message('errors_heading'), errors);
      return false;
    }
    feedback.hidden = true;
    return true;
  }
  button.addEventListener('click', validateSubmission, { capture: true });
  form.addEventListener('submit', event => {
    if (!validateSubmission(event)) return;
    if (preview) {
      event.preventDefault();
      setSubmitting(true);
      setTimeout(() => {
        setSubmitting(false);
        showError(message('preview_error'));
      },250);
      return;
    }
    if (!navigator.onLine) {
      event.preventDefault();
      showError(message('offline_error'));
      return;
    }
    rememberDraft();
    // Keep Shopify's native POST and CAPTCHA flow. No fetch, false success, or redirect guessing.
    // Let Shopify intercept a submit for verification before marking the native POST as pending.
    queueMicrotask(() => { if (!event.defaultPrevented) setSubmitting(true); });
  }, { capture: true });
  addEventListener('pageshow', event => {
    if (event.persisted) { setSubmitting(false); updateOrder(); }
  });
  form.querySelector('[data-server-error]')?.focus();
})();
